export default {
    notdone: {
        headers: {
            date: 'Date',
            name: 'Event',
            projects: 'Project',
            people: 'Person',
            contact: 'Contact person',
            organizations: 'Company',
            time: 'Time',
            comment: 'Comment',
            responsible: 'Responsible',
        }
    }
};
